export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sharetribe',
  url: 'https://www.sharetribe.com/',
  inLanguage: 'en-US',
};

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',

  // This is just an identifier, not an actual URL. See:
  // https://webmasters.stackexchange.com/questions/98569/what-is-the-use-of-id-in-json-ld-syntax
  '@id': 'https://www.sharetribe.com/#organization',
  name: 'Sharetribe',
  url: 'https://www.sharetribe.com/',
  logo: 'https://www.sharetribe.com/sharetribe-logo.png',
};

// This allows referring to the main org schema from a nested schema. For
// example, if an article defines the org as the published, this reference can
// be used to point to the organization.
export const organizationSchemaRef = {
  '@id': 'https://www.sharetribe.com/#organization',
};
